<button mat-icon-button aria-label="close dialog" mat-dialog-close style="float: right">
  <mat-icon>close</mat-icon>
</button>
<div style="clear: both"></div>
<div class="wrapper-content">
  <div class="wrapper-title">
    <h4 class="text-center card-title-page mb-4" mat-dialog-title>Edit {{ data.entityName }}</h4>
  </div>
  <div class="row d-flex justify-content-center">
    <div class="col-12 col-sm-9 col-sm-offset-1">
      <app-dynamic-form
        *ngIf="data.questions"
        [questions]="data.questions"
        [disabled]="!canEdit()"
        (hasChanged)="onChange($event)"
        (formSubmit)="onSubmit($event)"
      >
      </app-dynamic-form>
    </div>
  </div>
  <div class="modal-footer mt-4"></div>
  <div class="form-group-button text-center">
    <button *ngIf="canDelete()" (click)="onDelete()" disableRipple mat-button class="delete-user">
      <mat-icon matPreffix>delete</mat-icon>
      Delete {{ data.entityName }}
    </button>
  </div>
</div>
